import cx from 'classnames'
import React, { useCallback, useContext } from 'react'
import { Transforms } from 'slate'
import { ReactEditor, useReadOnly, useSlateStatic } from 'slate-react'

import { PermissionsContext } from '../context'

import checkboxStyles from './checkbox.module.css'
import styles from './index.module.scss'

export function CheckboxListItem ({ attributes, children, element }) {
  const editor = useSlateStatic()
  const isReadOnly = useReadOnly()
  const { isChecked } = element
  const { canEdit } = useContext(PermissionsContext)

  const handleChange = useCallback(event => {
    if (!canEdit || isReadOnly) {
      return
    }

    const path = ReactEditor.findPath(editor, element)

    Transforms.setNodes(
      editor,
      {
        isChecked: event.target.checked
      },
      {
        at: path
      }
    )
  }, [ canEdit, editor, element, isReadOnly ])

  return (
    <div
      {...attributes}
      className={cx(styles.checkboxListItem)}
    >
      <span
        contentEditable={false}
        className={cx(styles.inputWrapper)}
      >
        <input
          type='checkbox'
          className={cx(checkboxStyles.checkbox, 'border-2 border-gray-500 checked:border-primary')}
          checked={isChecked}
          onChange={handleChange}
        />
      </span>
      <span
        contentEditable={!isReadOnly}
        suppressContentEditableWarning
        className={styles.inputLabel}
      >
        {children}
      </span>
    </div>
  )
}
